import { apolloClient } from '~/apollo-client';
import {
  Flex_FetchUtilityConnectTokenQuery,
  Flex_FetchUtilityConnectTokenQueryVariables,
} from '~/typings/graphql';
import { FETCH_UTILITY_CONNECT_TOKEN } from './fetch-utility-connect-token.queries';

// token lasts for 2 hours - https://developers.arcadia.com/#operation/createConnectToken
export const fetchUtilityConnectToken = async (
  params: FetchUtilityConnectTokenParams,
): Promise<FetchUtilityConnectTokenResponse> => {
  const { utilityCredentialId } = params;

  const { data } = await apolloClient.query<
    Flex_FetchUtilityConnectTokenQuery,
    Flex_FetchUtilityConnectTokenQueryVariables
  >({
    fetchPolicy: 'no-cache',
    query: FETCH_UTILITY_CONNECT_TOKEN,
    variables: { utilityCredentialId },
  });
  return { utilityConnectToken: data.utilityCredentialConnectToken };
};

export interface FetchUtilityConnectTokenParams {
  utilityCredentialId: number;
}
export interface FetchUtilityConnectTokenResponse {
  utilityConnectToken: string;
}
